import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { ProjectsService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class ProjectBloc extends Bloc<ProjectsService['projectControllerGetOne']> {
    public constructor(service: ProjectsService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.projectControllerGetOne.bind(service), {
            debug: debug ?? false,
        });
    }
}
